const state = {
  flashMessage: '',
  flashStyle: 'success',
  flashDuration: 5000,
  flashIsModal: false,
  flashOnCloseModal: null,
  flashSubmitter: false,
};

const mutations = {
  setFlashMessage(state, { message }) { state.flashMessage = message; },
  setFlashStyle(state, { style }) { state.flashStyle = style; },
  setFlashDuration(state, { duration }) { state.flashDuration = duration; },
  setFlashIsModal(state, { isModal }) { state.flashIsModal = isModal; },
  setFlashOnCloseModal(state, { onCloseModal }) { state.flashOnCloseModal = onCloseModal; },
  submitFlash(state) { state.flashSubmitter = !(state.flashSubmitter); },
};

const dispatchFlash = style => ({ dispatch }, { message, duration = 5000, modal = false, onCloseModal = null }) => {
  dispatch('flash', { message, duration, style, modal, onCloseModal });
};

const actions = {
  async flash({ commit }, { message, style = 'success', duration = 5000, modal = false, onCloseModal = null }) {
    console.log(message);
    commit('setFlashOnCloseModal', { onCloseModal });
    commit('setFlashIsModal', { isModal: modal });
    commit('setFlashDuration', { duration });
    commit('setFlashStyle', { style });
    commit('setFlashMessage', { message });
    commit('submitFlash');
  },
  flashPrimary: dispatchFlash('primary'),
  flashSecondary: dispatchFlash('secondary'),
  flashSuccess: dispatchFlash('success'),
  flashDanger: dispatchFlash('danger'),
  flashWarning: dispatchFlash('warning'),
  flashInfo: dispatchFlash('info'),
  flashLight: dispatchFlash('light'),
  flashDark: dispatchFlash('dark')
};

const getters = {
  flashMessage({ flashMessage }) { return flashMessage; },
  flashStyle({ flashStyle }) { return flashStyle; },
  flashDuration({ flashDuration }) { return flashDuration; },
  flashIsModal({ flashIsModal }) { return flashIsModal; },
  flashOnCloseModal({ flashOnCloseModal }) { return flashOnCloseModal; },
  flashSubmitter({ flashSubmitter }) { return flashSubmitter; },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/flash/flash.js